export const downloadAsCsv = (values: string[]) => {
  const csv = values.join('\n');
  const blob = new Blob([csv], { type: 'text/csv' });
  const url = window.URL.createObjectURL(blob);
  const anchorElement = document.createElement('a');
  anchorElement.setAttribute('href', url);
  anchorElement.setAttribute('download', 'key.csv');
  anchorElement.click();
  window.URL.revokeObjectURL(url);
};
